module.exports = __webpack_public_path__ + "media/images/tables/round-eb0dab12cbf54c2748796e2bc2577aa3.png";